import React, { useState } from 'react'
import GoogleLoginButton from './GoogleLoginButton';
import PortaledModal from '../Modals/PortaledModal';
import OAuthAdditionalInfoModal from '../Modals/OAuthAdditionalInfoModal';
import * as http from '../../utils/http';
import { useCustomer } from '../../customHooks/useCustomer';
import * as SocialMediaTracker from "../../PixelTrackers/SocialMediaTracker";
import { REGISTRATION_COMPLETED_EVENT } from '../../utils/consts';




interface Props {
  redirectPath: string;
  cameFromPath:string;
  language: string;
  country: string;
  customerVerificationType?: string;
  onCompleteSignup?: () => void;
  onFailureSignup?: () => void;
  googleButtonId?: string;
}

const SocialLoginButtons: React.FC<Props> = ({ redirectPath, cameFromPath, language, country, customerVerificationType, onCompleteSignup, onFailureSignup, googleButtonId }) => {

  const { saveCustomer } = useCustomer();
  const [searchParams] = useState(new URLSearchParams(window.location.search));
  const [showOauthAdditionalInfoModal, setShowOauthAdditionalInfoModal] = useState(
    searchParams.get('showOauthAdditionalInfoModal') === 'true'
  );



  const handleAdditionalInfoModalSubmit = (formData: { dateOfBirth: string; gender: string; firstName: string; lastName: string }) => {
    
    // Prepare data in order to complete oauth signup
    const requestData = {
      birthday: formData.dateOfBirth,
      gender: formData.gender === 'male' ? 1 : 0,
      firstName: formData.firstName || searchParams.get('firstName') || '',
      lastName: formData.lastName || searchParams.get('lastName') || '',
      provider: searchParams.get('provider') || '',
      email: searchParams.get('email') || '',
      externalAccessToken: searchParams.get('externalAccessToken') || '',
      refreshToken: searchParams.get('refreshToken') || '',
      language: language,
      country: country,
      trackingData: window.eventsTracking && window.eventsTracking.getData(),
    };

    // Send data to backend (complete oauth signup)
    http.postToServer('auth/complete-oauth-signup', requestData)
      .then(res => {
        saveCustomer({
          customerID: res.data.customerID,
          uuid: res.data.uuid,
          token: res.data.token,
          email: res.data.email,
          optForSendables: res.data.optForSendables,
          fullName: res.data.customerFullName,
          loginSource: cameFromPath.includes("questionnaire") ? "questionnaire" : "socialLogin",
          provider: res.data.provider || 'local',
          isSignup: true,
          gender: res.data?.gender,
          lastPaidCategoryMention: '',
        });
        
        SocialMediaTracker.track("pv", REGISTRATION_COMPLETED_EVENT, {"email": res.data.email});

        onCompleteSignup && onCompleteSignup();
      })
      .catch(error => {
        window.clientLogger.error('Error completing OAuth signup:', error);
        
    
        
        onFailureSignup && onFailureSignup();
      });
  }

  const handleModalClose = () => {
    setShowOauthAdditionalInfoModal(false);
  }

  return (
    <>
      <PortaledModal
        shouldShowModal={showOauthAdditionalInfoModal}
        hideModal={() => { }}
      >
        <OAuthAdditionalInfoModal
          onSubmit={handleAdditionalInfoModalSubmit}
          onClose={handleModalClose}
          language={language}
        />
      </PortaledModal>

      <div id='social-login-buttons' className='flex flex-row w-full gap-2 items-start justify-center'>
        <GoogleLoginButton id={googleButtonId} redirectPath={redirectPath} customerVerificationType={customerVerificationType} cameFromPath={cameFromPath} language={language} country={country} />
      </div>

    </>
  )
}

export default SocialLoginButtons